/**
 * API Configuration
 * Centralized API URL management
 */

// Validate API URL is set at build time
const API_URL = process.env.REACT_APP_API_URL;

if (!API_URL) {
  // In development, show helpful error
  if (process.env.NODE_ENV === 'development') {
    console.error(
      'REACT_APP_API_URL is not set. Please create a .env file with:\n' +
      'REACT_APP_API_URL=http://localhost:3001/api'
    );
  }
  // In production, throw error to prevent deployment with missing config
  throw new Error(
    'REACT_APP_API_URL environment variable is required. ' +
    'Please set it in your build environment variables.'
  );
}

export const getApiUrl = (): string => {
  return API_URL;
};

export default API_URL;

